import { memo } from 'react'
import { RunnerSelect } from '../../runner-select'
import { InfoBlock } from '../../cells'

const RunnersBoxWrapperMock = ({
  runners,
  activeSubscription,
  translation,
}: {
  url?: string
  runners?: string[]
  activeSubscription?: boolean
  translation?: string
}) => {
  return (
    <InfoBlock notrunc>
      <RunnerSelect
        disabled={!activeSubscription}
        defaultRunners={runners ?? []}
        borderLess
        translation={translation}
      />
    </InfoBlock>
  )
}

export const RunnersBoxMock = memo(RunnersBoxWrapperMock)
